module.exports = __webpack_public_path__ + "static/media/desktop-InDepth.4ab55d72.png";